export const menuData = {
  day: {
    categories: [
      {
        id: "day-highlights",
        items: [
          {
            id: "english-breakfast",
            availability: "until_18",
            name: { en: "Full English Breakfast", pt: "Pequeno Almoço Inglês", fr: "Petit-Déjeuner", es: "Desayuno" },
            desc: { en: "Classic morning start.", pt: "O clássico pequeno-almoço.", fr: "Le classique.", es: "El clásico." },
          },
          {
            id: "monte-sol-burger",
            availability: "until_18",
            name: { en: "Monte Sol Burger", pt: "Hambúrguer Monte Sol", fr: "Burger Monte Sol", es: "Hamburguesa Monte Sol" },
            desc: { en: "With egg, cheese, bacon, tomato and ham.", pt: "Com ovo, queijo, bacon, tomate e fiambre.", fr: "Avec oeuf, fromage, bacon et jambon.", es: "Con huevo, queso, bacon y jamón." },
          },
        ],
      },
    ],
  },
  night: {
    categories: [
      {
        id: "night-highlights",
        items: [
          {
            id: "stone-steak",
            signature: true,
            availability: "all_day",
            name: { en: "Fillet Steak on Hot Stone", pt: "Bife do Lombo na Pedra", fr: "Filet sur Pierre", es: "Solomillo a la Pedra" },
            desc: { en: "Our house specialty.", pt: "A nossa especialidade da casa.", fr: "Notre spécialité.", es: "Nuestra especialidad." },
          },
        ],
      },
    ],
  },
};
